import { css } from "styled-components";
import { Backdrop, BackdropBackground, BackdropForeground } from "../../../../components/Backdrop";
import { EmailForm } from "../../components/CaptureForm";
import { BladeHeader, BladeHeaderBody } from "../../../../components/BladeHeader";
import { CTA } from "../../../../components/CTA";
const mediaQueryLayoutWithBackdrop = "@media (min-width: 901px)";
export const riotProductSkin = (chroma, paletteTokens) => css `
  & {
    --formWidth: 100%;
    --formMaxWidth: 600px;
    ${mediaQueryLayoutWithBackdrop} {
      --formWidth: clamp(50%, 50%, var(--formMaxWidth));
    }

    padding: ${chroma.spacers.variable.xxl};

    ${chroma.mediaQueries.tabletDown} {
      /* on smaller devices reduce side gutters */
      padding-left: ${chroma.spacers.variable.l};
      padding-right: ${chroma.spacers.variable.l};
    }
  }

  ${Backdrop} {
    pointer-events: none;
    ${BackdropForeground},
    ${BackdropBackground} {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;

      > img {
        height: 100%;
        width: 100%;
        object-fit: cover;
        object-position: 50%;
      }
    }
    ${BackdropForeground} {
      > img {
        display: none;
        ${chroma.mediaQueries.desktopUp} {
          display: block;
        }

        height: auto;
        width: 50%;
        max-height: 100%;
        object-fit: contain;
        object-position: right bottom;
        overflow: visible;
        position: absolute;
        bottom: 0;
        right: 0;
        transition: right 0.3s ease;
      }
    }
  }

  ${BladeHeader} {
    width: 100%;
    position: relative;

    h2 {
      ${chroma.typography.display4};
      color: ${paletteTokens.bladetext1};
      margin-bottom: ${chroma.spacers.variable.xl};
    }

    ${BladeHeaderBody} {
      width: var(--formWidth);
      max-width: var(--formMaxWidth);
    }
  }

  ${EmailForm} {
    width: var(--formWidth);
    max-width: var(--formMaxWidth);
    position: relative;
    min-height: 200px;
    margin: 0 auto;

    ${mediaQueryLayoutWithBackdrop} {
      margin: 0;
    }

    input {
      width: 100%;
    }

    .input-label {
      ${chroma.typography.body3}
      display: block;
      padding-top: 25px;
    }

    .agreement {
      ${chroma.typography.body3};
      color: ${paletteTokens.bladetext1};
      display: flex;
      justify-content: space-between;
      align-items: top;
      gap: 20px;
      padding-top: 50px;
      width: 100%;

      .terms {
        ${chroma.typography.body3};
      }
    }

    ${CTA} {
      ${chroma.typography.body3};
    }

    .hide {
      position: absolute;
      display: none;
    }

    .show {
      position: static;
      display: block;
    }

    .successMessage {
      ${chroma.typography.display6};
      width: 100%;
      position: static;
      margin-top: ${chroma.spacers.variable.xxl};

      &::after {
        content: "";
        display: block;
        width: 100%;
        height: 50px;
        margin-top: 25px;
        background: repeating-linear-gradient(45deg, #2c2e2f, #2c2e2f 5px, transparent 5px, transparent 10px);
        ${chroma.mediaQueries.tabletUp} {
          margin-top: 50px;
        }
      }
    }

    .submission {
      display: flex;
      flex-direction: column;
      flex-wrap: wrap;
      align-items: flex-start;
      margin-top: calc(${chroma.spacers.variable.m} * 2);

      ${mediaQueryLayoutWithBackdrop} {
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;
      }

      .error {
        ${chroma.typography.body3}
        color: ${paletteTokens.bladetext1};
        margin-left: 0;
        margin-top: ${chroma.spacers.variable.m};

        ${mediaQueryLayoutWithBackdrop} {
          margin-left: ${chroma.spacers.variable.m};
          margin-top: 0;
        }
      }
    }
  }
`;
//# sourceMappingURL=index.js.map